import { CascadiaColor } from "@certn/cascadia-tokens";
import React from "react";

import { TagSize, TagType, _Tag } from "./_Tag";

interface Status extends TagType {
  color?: CascadiaColor;
  fill?: CascadiaColor;
  size?: TagSize;
}

export type StatusTagType = Omit<Status, "type">;

export function StatusTag({
  testID = "status-tag",
  fill = "background-accent-neutral-medium",
  color = "text-base",
  statusInfoIcon = true,
  size,
  ...props
}: StatusTagType) {
  if (size === "small")
    return (
      <_Tag
        fill={fill}
        color={color}
        testID={testID}
        shape="pill"
        {...props}
        statusInfoIcon={false}
        leftIcon={undefined}
        style={{ minWidth: "max-content" }}
      />
    );

  return (
    <_Tag
      fill={fill}
      color={color}
      testID={testID}
      statusInfoIcon={statusInfoIcon}
      shape="pill"
      {...props}
      style={{ minWidth: "max-content" }}
    />
  );
}
